import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import kn from './locales/kn.json'
import { read, storageKeys, write } from '@/lib/storage'

/* Chrome strings only.

   Question CONTENT is never translated here — it comes from the backend in the
   medium the student chose, and its language is a property of the data, not of
   the interface. Mixing the two would let a student read Kannada questions
   inside English chrome, which is correct, or worse, let the interface try to
   translate a question, which is not. */

export const SUPPORTED_LOCALES = ['en', 'kn'] as const
export type Locale = (typeof SUPPORTED_LOCALES)[number]

function initialLocale(): Locale {
  const stored = read<Locale>(storageKeys.locale)
  if (stored !== null && SUPPORTED_LOCALES.includes(stored)) return stored
  return navigator.language.startsWith('kn') ? 'kn' : 'en'
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    kn: { translation: kn },
  },
  lng: initialLocale(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
})

export function setLocale(locale: Locale): void {
  void i18n.changeLanguage(locale)
  write(storageKeys.locale, locale)
  document.documentElement.lang = locale
}

document.documentElement.lang = i18n.language

export default i18n
